import React, { useEffect, useState } from "react";
import { ApolloProvider } from "@apollo/react-hooks";
import { func, string } from "prop-types";

import areaResolver from "../../../../shared/resolvers/area-resolver";
import apolloClient from "../../../../shared/utilities/graphql/apolloClient";
import { locations } from "../../propTypes";
import LocationFilterWidget from "../LocationFilterWidget";
import { getInitialAreas, updateSearchCookie } from "../sideEffects";

apolloClient.setResolvers(areaResolver);

const HomePageLocationFilterWidget = ({
  areaOptions,
  handleApply,
  rootElementId
}) => {
  const [selectedAreas, setSelectedAreas] = useState([]);

  useEffect(() => {
    setSelectedAreas(getInitialAreas(areaOptions));
  }, []);

  const applyHandler = areas => {
    updateSearchCookie(areas);
    setSelectedAreas(areas);
    handleApply();
  };

  return (
    <ApolloProvider client={apolloClient}>
      <LocationFilterWidget
        areaOptions={areaOptions}
        initialSelectedAreas={selectedAreas}
        onApply={applyHandler}
        rootElementId={rootElementId}
      />
      {selectedAreas.map(area => (
        <input key={area.id} name="area[]" type="hidden" value={area.id} />
      ))}
    </ApolloProvider>
  );
};

HomePageLocationFilterWidget.defaultProps = {
  handleApply: () => {}
};

HomePageLocationFilterWidget.propTypes = {
  areaOptions: locations.isRequired,
  handleApply: func,
  rootElementId: string.isRequired
};

export default HomePageLocationFilterWidget;
